/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchOperator } from './SearchOperator';
import {
    SearchOperatorFromJSON,
    SearchOperatorFromJSONTyped,
    SearchOperatorToJSON,
    SearchOperatorToJSONTyped,
} from './SearchOperator';
import type { LogicalOperator } from './LogicalOperator';
import {
    LogicalOperatorFromJSON,
    LogicalOperatorFromJSONTyped,
    LogicalOperatorToJSON,
    LogicalOperatorToJSONTyped,
} from './LogicalOperator';

/**
 * 
 * @export
 * @interface SearchCriteria
 */
export interface SearchCriteria {
    /**
     * 
     * @type {string}
     * @memberof SearchCriteria
     */
    field?: string;
    /**
     * 
     * @type {SearchOperator}
     * @memberof SearchCriteria
     */
    operator?: SearchOperator;
    /**
     * 
     * @type {any}
     * @memberof SearchCriteria
     */
    value?: any | null;
    /**
     * 
     * @type {LogicalOperator}
     * @memberof SearchCriteria
     */
    logicalOperator?: LogicalOperator;
}



/**
 * Check if a given object implements the SearchCriteria interface.
 */
export function instanceOfSearchCriteria(value: object): value is SearchCriteria {
    return true;
}

export function SearchCriteriaFromJSON(json: any): SearchCriteria {
    return SearchCriteriaFromJSONTyped(json, false);
}

export function SearchCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCriteria {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'] == null ? undefined : json['field'],
        'operator': json['operator'] == null ? undefined : SearchOperatorFromJSON(json['operator']),
        'value': json['value'] == null ? undefined : json['value'],
        'logicalOperator': json['logicalOperator'] == null ? undefined : LogicalOperatorFromJSON(json['logicalOperator']),
    };
}

export function SearchCriteriaToJSON(json: any): SearchCriteria {
    return SearchCriteriaToJSONTyped(json, false);
}

export function SearchCriteriaToJSONTyped(value?: SearchCriteria | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'operator': SearchOperatorToJSON(value['operator']),
        'value': value['value'],
        'logicalOperator': LogicalOperatorToJSON(value['logicalOperator']),
    };
}

